import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'evaluations-remotes',
    loadChildren: () =>
      import('./pages/evaluations-remotes/evaluations-remotes.module').then(
        (m) => m.EvaluationsRemotesPageModule
      ),
  },
  {
    path: 'stablishment',
    loadChildren: () =>
      import('./pages/stablishment/stablishment.module').then(
        (m) => m.StablishmentPageModule
      ),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
